import { Box, Grid, Switch, Tab, Tabs } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useState } from "react";
import { GetMandateReportsAction, GetReportRecruiterAction } from "../../../../../store/ATS/Report/Action";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  ConvertDateTime,
  DateConvertInDbFormat,
  getEmployeeId,
  getUserData,
} from "../../../Base/helper/baseFunctions";
import { GetAtsGroupCompanyAction } from "../../../../../store/ATS/GroupCompany/Action";
import { GetAtsCompanyAction } from "../../../../../store/ATS/Company/Action";
import DateRangeFilterDropdown from "../../../Base/views/DateRangeFilterDropdown";
import CustomToggle from "../../../Base/views/CustomToggle";

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
const MandateReport = () => {
  const dispatch = useDispatch();
  const user = getUserData();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({ load: true, values: [] });
  const [clientData, setClientData] = useState({ load: true, values: [] });
  const [groupOrgData, setGroupOrgData] = useState({ load: true, values: [] });
  const [selectedRows, setSelectedRows] = useState([]);
  const [filters, setFilters] = useState({
    primary_recruiter_filter: "",
    ats_company_id: "",
    ats_grouporg_id: "",
    from_date: DateConvertInDbFormat(),
    to_date: DateConvertInDbFormat(),
    dateRangeOption: "Today"
  });
  const [primaryRecruiterTab, setPrimaryRecruiterTab] = useState(false);
  const { atsMandateReport, isLoading } = useSelector(
    (state) => state.AtsReducer?.AtsReportReducer
  );
  const isGroupOrgFlow = user?.grouporg_flow === true;
  const { atsGroupCompanyData } = useSelector(
    (state) => state.AtsReducer?.AtsGroupCompanyReducer
  );
  const { atsCompanyData } = useSelector(
    (state) => state.AtsReducer?.AtsCompanyReducer
  );
  const [allRecruiter, setAllRecruiter] = useState(true);
  const [atsRecruiterData, setAtsRecruiterData] = useState([]);
  const [recruiterReady, setRecruiterReady] = useState(false);
  const getClientData = () => {
    if (isGroupOrgFlow) {
      atsGroupCompanyData &&
        setGroupOrgData({
          load: false,
          values: atsGroupCompanyData?.filter((el) => el.status === "Active"),
        });
    } else {
      atsCompanyData &&
        setClientData({
          load: false,
          values: atsCompanyData?.filter((el) => el.status === "Active"),
        });
    }
  };
  useEffect(() => {
    let clientId = null;
    if (isGroupOrgFlow) {
      clientId = filters?.ats_grouporg_id
        ? `{${filters?.ats_grouporg_id?.ats_grouporg_id}}`
        : null;
    } else {
      clientId = filters?.ats_company_id
        ? `{${filters?.ats_company_id?.ats_company_id}}`
        : null;
    }
    if (!recruiterReady) return;
    dispatch(
      GetMandateReportsAction({
        recruiter_id: filters?.primary_recruiter_filter ? `{${filters?.primary_recruiter_filter?.map((item) => item.ats_users_id).join(",")}}` : null,
        client_id: clientId,
        from_date: filters?.from_date,
        to_date: filters?.to_date,
        primary_recruiter_tab: primaryRecruiterTab,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, primaryRecruiterTab]);
  useEffect(()=> {
      const login_employee_id = allRecruiter ? null : getEmployeeId();
      dispatch(GetReportRecruiterAction({login_employee_id}, (resp) => {
          setUserData({ load: false, values: [] })
          setAtsRecruiterData(resp?.data?.data);
          if(allRecruiter) {
              setFilters((prev) => {return {...prev, primary_recruiter_filter: ""}})
          } else {
              setFilters((prev) => {return {...prev, primary_recruiter_filter: resp?.data?.data}})
          }
          setRecruiterReady(true); 
      }));
  },[allRecruiter, dispatch])
  useEffect(() => {
    if (isGroupOrgFlow) {
      dispatch(GetAtsGroupCompanyAction());
    } else {
      dispatch(GetAtsCompanyAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const handleFilter = (event, value) => {
    if (
      [
        "primary_recruiter_filter",
        "ats_company_id",
        "ats_grouporg_id",
      ].includes(event)
    ) {
      if (value) setFilters({ ...filters, [event]: value });
      else setFilters({ ...filters, [event]: "" });
    }
  };
  const handleExportSelected = () => {
    const headers = [
      { label: "Recruiter", key: "recruiter_name" },
      { label: "Client", key: "client_name" },
      { label: "Date of Mandate", key: "date_of_mandate" },
      { label: "Job ID", key: "job_id" },
      { label: "Job Title", key: "job_title" },
      { label: "Location", key: "job_location" },
      { label: "CTC", key: "ctc" },
      { label: "Days Pending", key: "days_pending" },
      { label: "Current Status", key: "status" },
      { label: "CTC Tag", key: "ctc_category" },
    ];
    const csvData = [headers.map((header) => header.label)];
    selectedRows.forEach((row) => {
      const rowData = headers.map((header) => {
      let value = row[header.key] ?? "";
      if (typeof value === "string" && value.includes(",")) {
          value = `"${value}"`; 
      }
       return value
      });
      csvData.push(rowData);
    });
    const csv = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = "Mandate_Report.csv";
    downloadLink.setAttribute("target", "_blank");
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  };
  const handleChange = (event, newValue) => {
    setLoading(true);
    setValue(newValue);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };
  const handleToggle = (e) => {
      setPrimaryRecruiterTab(!primaryRecruiterTab);
  };
  return (
    <Box mt={-1}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
            minHeight: "40px", mb: 1, ".MuiTab-root": { minHeight: "20px" },
            '& .MuiTabs-indicator': {
                width: '100%',
                display: 'flex',
                justifyContent: "center !important",
            },
        }} 
      >
        <Tab label={`Active`} {...a11yProps(0)} />
        <Tab label={`Inactive`} {...a11yProps(1)} />
        <Tab label={`Archive`} {...a11yProps(2)} />
      </Tabs>
      <Box sx={{ mt: 1 }}>
        <Grid container columnSpacing={1} mb={1}>
            {isGroupOrgFlow ? (
              <Grid key="grouporg_search_id" item xs={6} sm={3}>
                <SelectableSearch
                  isOptionEqualToValue={(option, value) =>
                    +option.ats_grouporg_id === +value.ats_grouporg_id
                  }
                  limitTags={2}
                  label="Group Organisation"
                  value={filters.ats_grouporg_id}
                  loading={getClientData}
                  fieldLabel="name"
                  required={false}
                  grouping={false}
                  variant={"outlined"}
                  name="ats_grouporg_id"
                  onChangeEvent={handleFilter}
                  data={groupOrgData}
                  size="small"
                />
              </Grid>
            ) : (
              <Grid key="client_id" item xs={6} sm={3}>
                <SelectableSearch
                  isOptionEqualToValue={(option, value) =>
                    +option.ats_company_id === +value.ats_company_id
                  }
                  label="Client"
                  value={filters.ats_company_id}
                  loading={getClientData}
                  fieldLabel="name"
                  required={false}
                  grouping={false}
                  variant={"outlined"}
                  name="ats_company_id"
                  onChangeEvent={handleFilter}
                  data={clientData}
                  size="small"
                />
              </Grid>
            )}
          <Grid key="primary_recruiter_id" item xs={6} sm={4}>
            <SelectableSearch
              isOptionEqualToValue={(option, value) =>
                +option.ats_users_id === +value.ats_users_id
              }
              label={allRecruiter ? "All Recruiter" : "My Recruiter"}
              multiple={true}
              value={filters.primary_recruiter_filter}
              loading={() =>
                setUserData({ load: false, values: atsRecruiterData })
              }
              limitTags={2}
              fieldLabel="first_name"
              required={false}
              grouping={true}
              variant={"outlined"}
              name="primary_recruiter_filter"
              onChangeEvent={handleFilter}
              data={userData}
              size="small"
            />
          </Grid>
          <Grid  item xs={6} sm={3}>
            <DateRangeFilterDropdown
              value={{
                from_date: filters.from_date,
                to_date: filters.to_date,
                option: filters.dateRangeOption,
              }}
              onChange={(val) =>
                setFilters({
                  ...filters,
                  from_date: val.from_date,
                  to_date: val.to_date,
                  dateRangeOption: val.option,
                })
              }
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <MaterialTable
          isLoading={isLoading || loading}
          columns={[
            {
              title: "Recruiter",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "recruiter_name",
              editable: "never",
            },{
              title: "Client",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "client_name",
              editable: "never",
            },
            {
              title: "Date of Mandate",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "date_of_mandate",
              editable: "never",
              render: (rowData) => {
                return rowData?.date_of_mandate
                  ? ConvertDateTime(rowData?.date_of_mandate)
                  : "    ";
              },
            },
            {
              title: "Job ID",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "job_id",
              editable: "never",
            },
            {
              title: "Job Title",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "job_title",
              editable: "never",
            },
            {
              title: "Location",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "job_location",
              editable: "never",
            },
            {
              title: "CTC",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "ctc",
              editable: "never",
            },
            {
              title: "Days Pending",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "days_pending",
              editable: "never",
            },
            {
              title: "Current Status",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "status",
              editable: "never",
            },
            {
              title: "CTC Tag",
              cellStyle: { padding: "5px 5px 5px 13px", textAlign: "left" },
              headerStyle: { padding: "10px", textAlign: "left" },
              field: "ctc_category",
              editable: "never",
            },
          ]}
          data={(atsMandateReport || [])?.filter((item) => {
            if (value === 0) return item?.status === "Active";
            if (value === 1) return item?.status === "Inactive";
            if (value === 2) return item?.status === "Archived";
            return true;
          })}
          options={{
            maxBodyHeight: "54vh",
            minBodyHeight: "54vh",
            sorting: true,
            search: true,
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            exportButton: false,
            exportAllData: true,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            showTextRowsSelected: true,
            selectionProps: (rowData) => ({
              disabled: [null, "", 0, "0"].includes(
                rowData.commission_percentage
              ),
            }),
            showSelectAllCheckbox: true,
            actionsColumnIndex: -1,
            grouping: false,
            addRowPosition: "first",
            columnsButton: false,
            draggable: false,
            selection: true,
          }}
          actions={[
            {
                icon: () => 
                  <Box
                    id="filters"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 1,
                    }}
                    >
                      <Box>
                        <Box sx={{ fontSize: "12px", fontWeight: 500 }}>
                            My Reportees
                        </Box>

                        <Switch
                            checked={!allRecruiter}
                            onChange={(e) => setAllRecruiter(!e.target.checked)}
                            size="small"
                        />
                      </Box>
                      <Box>
                        <CustomToggle
                            isChecked={!primaryRecruiterTab}
                            setIsChecked={handleToggle}
                            handleToggleChange={handleToggle}
                            NoText={"Primary Recruiter"}
                            Yestext={"Secondary Recruiter"}
                            style={{
                                height: "32px",
                                padding: "0px",
                                width: "250px",
                                fontSize: "12px",
                                labelPadding: "2px",
                                "&:hover": {
                                    backgroundColor: "#f3edfd !important",
                                },
                            }}
                        />
                      </Box>
                  </Box>,
                isFreeAction: true,
            },
            {
              icon: () => <CloudDownloadIcon />,
              tooltip: "Export Selected Rows",
              onClick: () => handleExportSelected(),
              hidden: selectedRows.length === 0,
            },
          ]}
          components={{
              Action: (props) => {
                  const ActionComponent = props?.components?.Action || MTableAction;
                  if (props?.action?.icon && typeof props?.action?.icon === "function") {
                  const IconElement = props?.action?.icon();
                  // Check if the rendered element is CustomToggle
                  if (IconElement?.props?.id === "filters") {
                      return (
                      <Box
                          sx={{
                              "& .MuiIconButton-root": {
                                  background: "transparent !important",
                                  boxShadow: "none !important",
                                  padding: "0px !important",
                                  margin: "0px !important",
                                  borderRadius: "0px !important",
                                  "&:hover": {
                                  background: "transparent !important",
                                  },
                              },
                              "& .MuiTouchRipple-root": {
                                  display: "none",
                              },
                          }}
                      >
                          <ActionComponent {...props} />
                      </Box>
                      );
                  }
                  }
                  return <ActionComponent {...props} />;
              },
          }}
          onSelectionChange={(rows) => setSelectedRows(rows)}
          title="Mandate Report"
        />
      </Box>
    </Box>
  );
};

export default MandateReport;